import axios from '@/utils/request'
import base from '../base'
import qs from 'qs'

export default {
  isAjax() {
    const headers = {
      isAjax: 'true'
    }
    return headers
  },
  header() {
    const headers = {
      'isAjax': 'true',
      'Content-Type': 'application/json'
    }
    return headers
  },
  /*查询我的状态*/
  queryMyStatus(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryMyStatus?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*获取本公司用户信息*/
  getThisList(data) {
    return axios.get(`${base.url_im}/auth/user/getThisList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*获取用户信息*/
  queryBizUserVo(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/queryBizUserVo?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询会话列表*/
  queryAcceptList(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryAcceptList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询客服状态*/
  queryServiceStatus(data) {
    return axios.post(`${base.url_im}/serviceNetty/api/chat/queryServiceStatus`, qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询客服消息数量*/
  queryUserMessageCount(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryUserMessageCount?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*删除客服消息数量*/
  deleteUserMessageCount(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/deleteUserMessageCount?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*接入会话*/
  connectSession(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/connectSession?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*接入全部会话*/
  connectAllSession(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/connectAllSession?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询待接入会话列表*/
  queryWaitAcceptList(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/queryWaitAcceptList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*传送对话*/
  sendSession(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/sendSession`, data, { headers: this.header() })
  },
  /*接受会话*/
  acceptSession(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/acceptSession`, data, { headers: this.header() })
  },
  /*拒绝会话*/
  rejectSession(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/rejectSession`, data, { headers: this.header() })
  },
  /*结束会话*/
  finishSession(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/finishBatchSession`, qs.stringify(data))
  },
  /*查询传送在线客服列表*/
  querySendOnlineServiceList(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/querySendOnlineServiceList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*聊天记录*/
  queryUserChatMessageList(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryUserChatMessageList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*待评估列表*/
  querySessionListPage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizUserAccess/querySessionListPage`, data, { headers: this.header() })
  },
  /*会话记录新增是否阅读标记*/
  addAccessViewTag(data) {
    return axios.get(`${base.url_im}/serviceBusiness/bizUserAccess/addAccessViewTag?` + qs.stringify(data), { headers: this.header() })
  },
  /*查询传送会话列表*/
  querySendSessionList(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/querySendSessionList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*分页查询用户会话列表*/
  queryBizUserAccessListPage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizUserAccess/queryBizUserAccessListPage`, data, { headers: this.header() })
  },
  /*客服修改用户信息*/
  serviceUpdateUser(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizUser/serviceUpdateUser`, data, { headers: this.header() })
  },
  /*客服评估*/
  updateAssessmentStatus(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/updateAssessmentStatus`, data, { headers: this.header() })
  },
  /*客服列表评估*/
  updateListAssessmentStatus(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/chat/updateListAssessmentStatus`, data, { headers: this.header() })
  },
  /*获取客服红点标记*/
  queryServiceMark(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryServiceMark?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询公聊聊天记录列表*/
  queryCommonServiceChatMessageList(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/queryCommonServiceChatMessageList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询私聊聊天记录列表*/
  queryPrivateServiceChatMessageList(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/queryPrivateServiceChatMessageList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*分页查询用户信息列表*/
  queryBizUserListPage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizUser/queryBizUserListPage`, data, { headers: this.header() })
  },
  /*分页查询用户留言列表*/
  queryBizLeaveMessageListPage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizLeaveMessage/queryBizLeaveMessageListPage`, data, { headers: this.header() })
  },
  /*分页查询用户留言列表*/
  exportLeaveMessage(data) {
    return `${base.url_im}/serviceBusiness/bizLeaveMessage/exportLeaveMessage`
  },
  /*根据id更新用户会话*/
  updateBizUserAccess(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizUserAccess/updateBizUserAccess`, data, { headers: this.header() })
  },
  /*根据id更新用户会话*/
  updateBizLeaveMessage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/bizLeaveMessage/updateBizLeaveMessage`, data, { headers: this.header() })
  },
  /*留言记录新增是否阅读标记*/
  addMessageViewTag(data) {
    return axios.get(`${base.url_im}/serviceBusiness/bizLeaveMessage/addMessageViewTag?` + qs.stringify(data), { headers: this.header() })
  },
  /*查询客服私聊消息数量*/
  queryServiceSingleMessageCount(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryServiceSingleMessageCount?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*删除客服私聊消息数量*/
  deleteServiceSingleMessageCount(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/deleteServiceSingleMessageCount?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*新增监控*/
  addMonitor(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/addMonitor?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*移除监控*/
  removeMonitor(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/removeMonitor?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*更新客服当前会话*/
  updateServiceCurrentSession(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/updateServiceCurrentSession?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询客服当前会话*/
  queryServiceCurrentSession(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/queryServiceCurrentSession?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询智能客服待分配会话列表*/
  queryWaitAssignList(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryWaitAssignList?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*接入智能客服待分配会话*/
  connectWaitAssignSession(data) {
    return axios.get(`${base.url_im}/serviceNetty/admin/chat/connectWaitAssignSession?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*分页查询知识列表*/
  queryConKnowledgeListPage(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conKnowledge/queryConKnowledgeListPage`, data, { headers: this.header() })
  },
  /*查询知识分类列表*/
  queryConKnowledgeCategoryList(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conKnowledgeCategory/queryConKnowledgeCategoryList`, data, { headers: this.header() })
  },
  /*新增场景配置*/
  addConSceneKnowledge(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conSceneKnowledge/addConSceneKnowledge`, data, { headers: this.header() })
  },
  /*根据id更新场景配置*/
  updateConSceneKnowledge(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conSceneKnowledge/updateConSceneKnowledge`, data, { headers: this.header() })
  },
  /*查询场景知识*/
  querySceneConKnowledge(data) {
    return axios.post(`${base.url_im}/serviceBusiness/conKnowledge/querySceneConKnowledge`, qs.stringify(data), { headers: this.isAjax() })
  },
  /*更新自动回复状态*/
  updateAutoAnswerStatus(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/updateAutoAnswerStatus?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*查询自动回复状态*/
  queryAutoAnswerStatus(data) {
    return axios.get(`${base.url_im}/serviceNetty/api/chat/queryAutoAnswerStatus?` + qs.stringify(data), { headers: this.isAjax() })
  },
  /*获取可以可翻译的语言配置*/
  translateLang() {
    return axios.get(`${base.url_im}/serviceNetty/admin/transtate/translateLang`, { headers: this.isAjax() })
  },
  /*翻译文本内容*/
  translateText(data) {
    return axios.post(`${base.url_im}/serviceNetty/admin/transtate/translateText`, qs.stringify(data), { headers: this.isAjax() })
  }
}
